import React, { useEffect } from "react";
import {
  Typography,
  createStyles,
  makeStyles,
  Box,
  Grid,
  Container,
  Card,
  CardMedia,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import i18next from "../../../../config/lang/i18n";
import { useSpring, animated } from "react-spring";
import Avatar from "@material-ui/core/Avatar";

const useStyles = makeStyles(() =>
  createStyles({
    title: {
      flexGrow: 1,
      fontSize: 24,
      fontWeight: 700,
      // color: "#0F4C81",
      //   color: "#bc243c",
      color: "white",

      fontFamily: "GmarketSansBold",
    },
  })
);

function CompanyName() {
  // topState: any
  const classes = useStyles();

  // let scrollValue = topState.topState.topState;
  // let inJudege = topState.topState.judege;

  // const [{ color }, set] = useSpring(() => ({
  //   color: "white",
  // }));

  // useEffect(() => {
  //   if (scrollValue) {
  //     set({
  //       color: "#bc243c",
  //     });
  //   } else {
  //     set({
  //       color: "white",
  //       // color: "rgb(188, 36, 60)",
  //     });
  //   }
  //   return () => {};
  // }, [scrollValue]);

  // useEffect(() => {
  //   if (inJudege) {
  //     set({
  //       color: "#bc243c",
  //     });
  //   } else if (scrollValue && inJudege == false) {
  //     set({
  //       color: "#bc243c",
  //     });
  //   } else {
  //     set({
  //       color: "white",
  //       // color: "rgb(188, 36, 60)",
  //     });
  //   }
  //   return () => {};
  // }, [scrollValue, inJudege]);

  return (
    <Grid xs={12} item container alignItems={"center"}>
      <Link to={"/"} style={{ display: "flex" }}>
        <Grid container style={{ marginRight: 16 }}>
          <Grid
            component={"img"}
            // container
            alignContent={"center"}
            style={{ height: 56 }}
            src={"/images/main/logo1.png"}
          ></Grid>
        </Grid>{" "}
        {/* </Link> */}
        {/* <Link to={"/"} style={{ textDecoration: "none" }}> */}
        <Grid container style={{ height: 56 }} alignItems={"center"}>
          <Grid
            component={"img"}
            // container
            // alignContent={"center"}
            style={{ height: 42 }}
            src={"/images/main/logo.png"}
          ></Grid>
        </Grid>
      </Link>
    </Grid>
  );
}

export default CompanyName;
